import { render, staticRenderFns } from "./MTDetail.vue?vue&type=template&id=5606fa72&scoped=true"
import script from "./MTDetail.vue?vue&type=script&lang=js"
export * from "./MTDetail.vue?vue&type=script&lang=js"
import style0 from "./MTDetail.vue?vue&type=style&index=0&id=5606fa72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606fa72",
  null
  
)

export default component.exports